import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../UserDashboard/dashboardConfig";

// Style wspólne dla stron z tabelą w nowym wyglądzie (Rejestr wniosków, Kontrola wewnętrzna).
// Wygląd jest spójny z UserDashboard: biała karta, niebieski akcent, lepki nagłówek tabeli.
export const usePageStyles = makeStyles((theme) => ({
  main: {
    minHeight: "100vh",
    background: "#fff",
    transition: "margin-left 0.2s ease",
    padding: theme.spacing(3, 4, 4),
    boxSizing: "border-box",
    minWidth: 0,
  },
  pageHeader: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
  title: {
    margin: 0,
    fontSize: 28,
    fontWeight: 800,
    color: COLORS.primaryDark,
    lineHeight: 1.2,
  },
  subtitle: {
    marginTop: 4,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    fontSize: 14,
    color: COLORS.textMuted,
  },
  headerActions: { display: "flex", flexWrap: "wrap", gap: theme.spacing(1) },
  card: {
    background: "#fff",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
  },
  search: {
    display: "flex",
    alignItems: "center",
    flex: "1 1 320px",
    maxWidth: 520,
    height: 40,
    padding: theme.spacing(0, 1.5),
    borderRadius: 8,
    border: `1px solid ${COLORS.border}`,
    background: "#fafafa",
    transition: "background-color 0.2s, box-shadow 0.2s, border-color 0.2s",
    "&:hover": { background: "#f0f0f0" },
    "&:focus-within": {
      background: "#fff",
      borderColor: COLORS.primary,
      boxShadow: "0 0 0 3px rgba(25,118,210,0.15)",
    },
    "& svg": { color: "#757575" },
  },
  searchInput: { flex: 1, marginLeft: theme.spacing(1), fontSize: 14.5 },
  kbd: {
    padding: "1px 7px",
    borderRadius: 4,
    border: `1px solid ${COLORS.border}`,
    background: "#fff",
    color: "#9e9e9e",
    fontSize: 12,
    fontFamily: "inherit",
  },
  toolbarGap: { flex: 1 },
  presetChip: { height: 32, fontWeight: 600, fontSize: 13.5 },
  segmented: {
    display: "inline-flex",
    padding: 3,
    borderRadius: 8,
    background: "#eef2f7",
  },
  segment: {
    height: 32,
    padding: "0 14px",
    border: "none",
    borderRadius: 6,
    background: "transparent",
    color: "#546e7a",
    fontSize: 13.5,
    fontWeight: 600,
    fontFamily: "inherit",
    cursor: "pointer",
    transition: "background-color 0.15s, color 0.15s",
    "&:hover": { color: COLORS.primaryDark },
  },
  segmentActive: {
    background: "#fff",
    color: COLORS.primaryDark,
    fontWeight: 800,
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
  },
  activeFilters: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(0.75),
    padding: theme.spacing(1, 2, 1.5),
    borderTop: `1px solid ${COLORS.borderSoft}`,
  },
  selectionBar: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 2),
    background: COLORS.primarySoft,
    borderTop: "1px solid #bbdefb",
    borderLeft: `5px solid ${COLORS.primary}`,
    fontSize: 14,
    color: COLORS.primaryDark,
  },
  tableWrap: {
    position: "relative",
    maxHeight: "calc(100vh - 150px)",
    minHeight: 240,
    overflow: "auto",
    borderTop: `1px solid ${COLORS.border}`,
  },
  progress: { position: "absolute", top: 0, left: 0, right: 0, zIndex: 5, height: 3 },
  headCell: {
    backgroundColor: "#f5f8fc !important",
    borderBottom: `2px solid ${COLORS.primary} !important`,
    padding: "10px 12px !important",
    fontSize: "12.5px !important",
    fontWeight: "800 !important",
    letterSpacing: 0.3,
    color: "#37474f !important",
    whiteSpace: "nowrap",
    "&.MuiTableCell-paddingCheckbox": { padding: "0 2px 0 12px !important" },
    "&.MuiTableCell-paddingNone": { padding: "0 !important" },
  },
  headSticky: { position: "sticky", zIndex: 4 },
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(8, 2),
    color: COLORS.textMuted,
    textAlign: "center",
  },
  error: {
    margin: theme.spacing(1.5, 2),
    padding: theme.spacing(1, 2),
    borderRadius: 6,
    background: "#ffebee",
    borderLeft: `5px solid ${COLORS.danger}`,
    color: "#b71c1c",
    fontSize: 14,
  },
  legend: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75, 2),
    padding: theme.spacing(1.25, 2),
    fontSize: 13,
    color: COLORS.textMuted,
  },
  legendItem: { display: "inline-flex", alignItems: "center", gap: 6 },
  legendTone: {
    width: 12,
    height: 12,
    borderRadius: 3,
    flexShrink: 0,
    border: "1px solid rgba(0,0,0,0.15)",
  },

  // ---------------- Wiersze ----------------
  row: {
    "&:hover > td": { backgroundColor: "#f5f9ff" },
    // Komorki z checkboxem / przyciskiem maja zerowy padding - inaczej reguła "& > td" je
    // poszerza i przypiete kolumny (left: 0 / 44 / 84) przestaja do siebie przylegac.
    "& > td.MuiTableCell-paddingCheckbox": { padding: "0 2px 0 12px" },
    "& > td.MuiTableCell-paddingNone": { padding: 0 },
    "& > td": {
      borderBottom: `1px solid ${COLORS.borderSoft}`,
      padding: "6px 12px",
      fontSize: 14,
      color: "#212121",
      backgroundColor: "#fff",
      verticalAlign: "middle",
    },
  },
  rowWarn: {
    "& > td": { backgroundColor: "#fffde7" },
    "&:hover > td": { backgroundColor: "#fff9c4" },
    "& > td:first-child": { boxShadow: `inset 4px 0 0 ${COLORS.warning}` },
  },
  rowAlert: {
    "& > td": { backgroundColor: "#fff3e0" },
    "&:hover > td": { backgroundColor: "#ffe0b2" },
    "& > td:first-child": { boxShadow: "inset 4px 0 0 #e65100" },
  },
  rowDanger: {
    "& > td": { backgroundColor: "#fff1f1" },
    "&:hover > td": { backgroundColor: "#ffe3e3" },
    "& > td:first-child": { boxShadow: `inset 4px 0 0 ${COLORS.danger}` },
  },
  rowMuted: {
    "& > td": { backgroundColor: "#f1f2f4", color: "#616161" },
    "&:hover > td": { backgroundColor: "#e6e8eb" },
    "& > td:first-child": { boxShadow: "inset 4px 0 0 #9e9e9e" },
  },
  rowSelected: { "& > td": { backgroundColor: "#e8f1fb !important" } },
  stickyCell: { position: "sticky", zIndex: 2 },
  stickyEdge: { boxShadow: "inset -1px 0 0 #e0e0e0" },
  link: {
    fontWeight: 700,
    color: COLORS.primary,
    textDecoration: "none",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    fontFamily: "inherit",
    fontSize: "inherit",
    textAlign: "left",
    // Numer nigdy nie jest ucinany - kolumna dopasowuje szerokość do jego długości.
    whiteSpace: "nowrap",
    "&:hover": { textDecoration: "underline", color: COLORS.primaryDark },
  },
  // Wartość z dodatkiem obok (np. plakietka "Duplikat") - tekst się przycina, plakietka zostaje.
  inlineNoWrap: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
    flexWrap: "nowrap",
    "& > :not($grow)": { flexShrink: 0 },
  },
  grow: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  muted: { color: "#bdbdbd" },
  ellipsis: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 12,
    fontSize: 12.5,
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  dot: { width: 8, height: 8, borderRadius: "50%", flexShrink: 0 },
  inline: { display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" },
  actions: { display: "flex", justifyContent: "flex-end", gap: 2 },

  // ---------------- Rozwijany panel (historia / komentarze) ----------------
  detailCell: {
    padding: "0 !important",
    backgroundColor: "#fafcff !important",
    borderBottom: "none !important",
  },
  detailCellOpen: { borderBottom: `1px solid ${COLORS.border} !important` },
  detailWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  detailCard: {
    flex: "1 1 420px",
    minWidth: 300,
    background: "#fff",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  detailTitle: {
    padding: theme.spacing(1, 2),
    fontSize: 15,
    fontWeight: 800,
    color: COLORS.primary,
    borderBottom: `2px solid ${COLORS.primary}`,
  },
  detailList: { maxHeight: 260, overflowY: "auto", padding: theme.spacing(0.5, 2) },
  detailItem: {
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${COLORS.borderSoft}`,
    fontSize: 13.5,
    "&:last-child": { borderBottom: "none" },
  },
  detailMeta: { color: "#777", fontSize: 12.5 },
  detailChange: { marginTop: 2 },
  detailEmpty: { padding: theme.spacing(2), color: "#9e9e9e", fontSize: 14 },
}));
